import { Directive, Input, TemplateRef, ViewContainerRef } from '@angular/core';
import { AuthService } from '../services/AuthService';

/**
 * Структурная директива для скрытия/показа элементов по permission'у.
 *
 * Использование:
 *   <button *hasPermission="'orders.delete'">Удалить</button>
 *   <button *hasPermission="['orders.delete', 'orders.edit']">Действие</button>
 *
 * Массив трактуется как ANY-семантика: достаточно одного из permission'ов.
 * super_admin проходит всегда (через auth.hasPermission).
 *
 * Реакция на runtime-изменение permission'ов не требуется: они меняются
 * через /me, после чего обычно происходит навигация и компонент пересоздаётся.
 */
@Directive({ selector: '[hasPermission]' })
export class HasPermissionDirective {
  private shown = false;

  constructor(
    private tpl: TemplateRef<unknown>,
    private vcr: ViewContainerRef,
    private auth: AuthService
  ) {}

  @Input() set hasPermission(value: string | string[]) {
    const required = Array.isArray(value) ? value : [value];
    const allowed = this.auth.hasAnyPermission(required);

    if (allowed && !this.shown) {
      this.vcr.createEmbeddedView(this.tpl);
      this.shown = true;
    } else if (!allowed && this.shown) {
      this.vcr.clear();
      this.shown = false;
    }
  }
}
